import React, { Component } from 'react';
import ReactDOM from 'react-dom';
//import './index.css';
import "typeface-roboto";

//akhan
import { BrowserRouter, Route, Redirect, Switch } from 'react-router-dom';
import Login from './Auth/Login';
import Register from './Auth/Register';
import Forget from './Auth/Forget';
import awsmobile from './aws-exports';
import Amplify from 'aws-amplify';
import {Auth} from 'aws-amplify';
//import './css/general.css';
import ResponsiveDrawer from './components/dashboard/ResponsiveDrawerNew';
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';


Amplify.configure(awsmobile);

// New custom theme
// blue: #51B0DE
// yellow: #F3D450
// black: #231F20
// red: #BB4430
// light yellow: #F3DFA2

const theme = createMuiTheme({
  palette: {
    primary: {
      light: '#F3D450',
      main: '#BB4430',
      //main: '#4F5D75',
      //: '#004c8c',
      //dark: '#2D3142',
      dark: '#FFFFFF',
      nav: '#FFFFFF',
      contrastText: '#ffffff',
    },
    secondary: {
      light: '#F3DFA2',
      main: '#EF8354',
      dark: '#231F20',
      contrastText: '#000000',
    },
  },
});

// primary: {
//   light: '#58a5f0',
//   //main: '#0277bd',
//   main: '#f07878',
//   //: '#004c8c',
//   dark: '#ed1411',
//   nav: '#f9e06c',
//   contrastText: '#ffffff',
// },

// const PublicRoute = ({ component: Component, authStatus, ...rest}) => (
//     <Route {...rest} render={props => authStatus == false
//         ? ( <Component {...props} /> ) : (<Redirect to="/main" />)
//     } />
// )

// const PrivateRoute = ({ component: Component, authStatus, ...rest}) => (
//     <Route {...rest} render={props => authStatus == false
//         ? ( <Redirect to="/login" /> ) : ( <Component {...props} /> )
//     } />
// )

const MainRoute = ({ component: Component, authStatus, username, onAuthComplete, ...rest }) => (
  <Route {...rest} render={props => (
      <Component authStatus={authStatus} username={username} onAuthComplete={onAuthComplete} {...props}/>
  )}/>
)

class App extends Component {

    constructor(props) {
        super(props);
        this.state = {
          authStatus: this.props.authStatus || false,
          username: null
        }
        this.handleWindowClose = this.handleWindowClose.bind(this);
        this.validateUserSession = this.validateUserSession.bind(this);

    }

    handleWindowClose = async (e) => {
        e.preventDefault();
        Auth.signOut()
            .then(
                localStorage.setItem('isLoggedIn', false),
                this.setState(() => {
                    return {
                        authStatus: false,
                        username: null
                    }
                })
            )
            .catch(err => console.log(err))
    }

    componentWillMount() {
        //console.log('index componentWillMount');
        this.validateUserSession();
        //window.addEventListener('beforeunload', this.handleWindowClose);

    }

    // componentDidUpdate(prevProps) {
    //   console.log('index componentDidUpdate');
    // }
    //
    // componentWillUnMount() {
    //     //window.removeEventListener('beforeunload', this.handleWindowClose);
    //
    // }


    validateUserSession() {
        //console.log('in index validateUserSession()');
        let checkIfLoggedIn = localStorage.getItem('isLoggedIn');
        let _username = localStorage.getItem('username')
        if(checkIfLoggedIn === 'true'){
            //console.log('index.js: the user is logged in');
            this.setState(() => {
                return {
                    authStatus: true,
                    username: _username
                }
            })
        } else {
            //console.log('index.js: the user is NOT logged in');
            this.setState(() => {
                return {
                    authStatus: false,
                    username: null
                }
            })
        }
    }

    render() {
        const {authStatus, username} = this.state;

        return (
          <MuiThemeProvider theme={theme}>
            <BrowserRouter basename='/explore'>
                <Switch>
                    <Route exact path="/favorites" render={() => (
                      authStatus ? (
                        <MainRoute authStatus={authStatus} username={username}  onAuthComplete={this.validateUserSession} component={ResponsiveDrawer} />
                      ) : (
                        <Login onAuthComplete={this.validateUserSession}/>
                      )
                    )}/>

                    <Route exact path="/settings" render={() => (
                      authStatus ? (
                        <MainRoute authStatus={authStatus} username={username} onAuthComplete={this.validateUserSession} component={ResponsiveDrawer} />
                      ) : (
                        <Login onAuthComplete={this.validateUserSession}/>
                      )
                    )}/>

                    <Route exact path="/login" render={() => (
                      authStatus ? (
                        <Redirect to="/"/>
                      ) : (
                        <Login onAuthComplete={this.validateUserSession}/>
                      )
                    )}/>


                    <Route exact path="/register" render={() => (
                      authStatus ? (
                        <Redirect to="/"/>
                      ) : (
                        <Register/>
                      )
                    )}/>

                    <Route exact path="/forget" render={() => (
                      authStatus ? (
                        <Redirect to="/"/>
                      ) : (
                        <Forget/>
                      )
                    )}/>


                    <MainRoute authStatus={authStatus} username={username} onAuthComplete={this.validateUserSession} component={ResponsiveDrawer} />



                    <Route render={() => (<Redirect to="/blah" />)} />
                </Switch>
            </BrowserRouter>
          </MuiThemeProvider>
        );
    }
}

ReactDOM.render(<App />, document.getElementById('root'));
//export default App;



// WEBPACK FOOTER //
// ./src/index.js